import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiHome, FiList, FiUserPlus, FiUsers, FiLogIn, FiLogOut, FiCommand, FiUserCheck, FiMonitor ,FiPhoneForwarded, FiMessageCircle} from "react-icons/fi";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const menuItems = [
    { path: "/CreateSociety", icon: <FiHome size={20} />, label: "SOCIETY PROFILE" },
    { path: "/SocietyList", icon: <FiList size={20} />, label: "SOCIETY LIST" },
    { path: "/CreateSocietyAdmin", icon: <FiUserPlus size={20} />, label: "ADD SOCIETY ADMIN" },
    { path: "/CreateSocietyAdminList", icon: <FiUsers size={20} />, label: "SOCIETY ADMIN LIST" },
    { path: "/request-call", icon: <FiPhoneForwarded size={20} />, label: "REQUEST CALL"  },
    { path: "/user-query", icon: <FiUserCheck size={20} />, label: "USER QUERY" },
    { path: "/comments", icon: <FiMessageCircle  size={20} />, label: "COMMENTS" },
    { path: "/request-demo", icon: <FiMonitor   size={20} />, label: "Request For Demo" },
    { path: "/all-admin-login", icon: <FiLogIn size={20} />, label: "ALL LOGIN ADMIN" },
  ];

  return (
    <div className={`flex flex-col gap-2 transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] relative bg-bg-primary border-r border-border
      ${collapsed ? "w-[80px]" : "w-[280px]"}
      min-h-screen z-50
      max-[900px]:w-[80px]
      max-[500px]:w-full max-[500px]:h-auto max-[500px]:flex-row max-[500px]:border-r-0 max-[500px]:border-t max-[500px]:fixed max-[500px]:bottom-0
      `}>

      {/* Brand Header */}
      <div className={`flex items-center gap-3 p-6 h-20 ${collapsed ? "justify-center" : "justify-between"} max-[500px]:hidden`}>
        {!collapsed && (
          <div className="flex items-center gap-2 overflow-hidden whitespace-nowrap">
            <div className="w-8 h-8 bg-signal-orange flex items-center justify-center flex-shrink-0">
              <FiCommand className="text-bg-primary text-xl" />
            </div>
            <span onClick={() => navigate("/welcome")} className="font-clash font-bold text-lg text-text-main tracking-widest uppercase">SUPER ADMIN</span>
          </div>
        )}
        {collapsed && (
          <div className="w-8 h-8 bg-signal-orange flex items-center justify-center flex-shrink-0">
            <FiCommand className="text-bg-primary text-xl" />
          </div>
        )}
        <button
          className="bg-transparent border border-border rounded hover:bg-bg-tertiary text-text-muted cursor-pointer w-6 h-6 flex items-center justify-center text-xs"
          onClick={toggleSidebar}
        >
          {collapsed ? ">" : "<"}
        </button>
      </div>

      {/* Navigation */}
      <div className="flex-1 px-3 py-4 flex flex-col gap-1 overflow-y-auto max-[500px]:flex-row max-[500px]:justify-around max-[500px]:p-2">
        {menuItems.map((item) => (
          <SidebarBtn
            key={item.path}
            onClick={() => navigate(item.path)}
            icon={item.icon}
            label={item.label}
            collapsed={collapsed}
            isActive={location.pathname === item.path}
          />
        ))}

        <div className="mt-auto pt-4 border-t border-border max-[500px]:hidden">
          <SidebarBtn
            onClick={handleLogout}
            icon={<FiLogOut size={20} />}
            label="LOGOUT"
            collapsed={collapsed}
            isDestructive
          />
        </div>
      </div>
    </div>
  );
};

const SidebarBtn = ({ onClick, icon, label, collapsed, isActive, isDestructive }) => (
  <button
    onClick={onClick}
    className={`
      flex items-center gap-4 rounded-none p-3.5 cursor-pointer font-satoshi font-medium transition-all duration-300 group relative overflow-hidden
      ${collapsed ? "justify-center" : ""} 
      ${isActive
        ? "bg-bg-secondary text-text-main"
        : isDestructive
          ? "text-red-500 hover:bg-red-500/10"
          : "text-text-muted hover:text-text-main hover:bg-bg-tertiary"
      }
      max-[900px]:justify-center
      max-[500px]:flex-col max-[500px]:p-2 max-[500px]:gap-1 max-[500px]:rounded-lg
    `}
  >
    {/* Active Indicator Line */}
    {isActive && !isDestructive && (
      <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-signal-orange max-[500px]:w-full max-[500px]:h-[3px] max-[500px]:top-auto max-[500px]:bottom-0"></div>
    )}

    <span className={`relative z-10 ${isActive ? "text-signal-orange" : ""} group-hover:scale-110 transition-transform duration-300`}>
      {icon}
    </span>

    <span className={`
      whitespace-nowrap text-sm tracking-wide relative z-10
      ${collapsed ? "hidden" : "block"}
      max-[900px]:hidden
      max-[500px]:hidden
    `}>
      {label}
    </span>

    {/* Hover Glow Effect */}
    <div className="absolute inset-0 bg-bg-tertiary opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
  </button>
);

export default Sidebar;
